/**
 * Modern Dark Theme - 现代深色高端主题
 * 大气高端风格，深色背景配合金铜色点缀
 */

export const modernDarkTheme = {
  name: 'dark',
  displayName: {
    zh: '现代深色',
    en: 'Modern Dark'
  },
  
  // CSS 变量定义
  cssVariables: {
    // ===== 背景色 =====
    '--theme-bg-primary': '#0a0f1a',
    '--theme-bg-secondary': '#111827',
    '--theme-bg-card': 'rgba(26, 35, 50, 0.8)',
    '--theme-bg-elevated': '#243044',
    '--theme-bg-nav': 'rgba(10, 15, 26, 0.95)',
    '--theme-bg-footer': 'linear-gradient(180deg, #0a0f1a 0%, #111827 100%)',
    '--theme-bg-hero': 'linear-gradient(135deg, #0a0f1a 0%, #1a2332 50%, #0a0f1a 100%)',
    
    // ===== 强调色 =====
    '--theme-accent-primary': '#c9a962',
    '--theme-accent-secondary': '#e8d5a8',
    '--theme-accent-highlight': '#c9a962',
    '--theme-accent-danger': '#ef4444',
    '--theme-accent-success': '#22c55e',
    '--theme-accent-gradient': 'linear-gradient(135deg, #c9a962 0%, #8b7355 100%)',
    '--theme-accent-cta': 'linear-gradient(135deg, #c9a962 0%, #a08347 100%)',
    
    // ===== 文字色 =====
    '--theme-text-primary': '#ffffff',
    '--theme-text-secondary': '#94a3b8',
    '--theme-text-muted': '#64748b',
    '--theme-text-on-dark': '#ffffff',
    '--theme-text-on-accent': '#0a0f1a',
    '--theme-text-link': '#c9a962',
    '--theme-text-link-hover': '#e8d5a8',
    
    // ===== 边框色 =====
    '--theme-border-primary': 'rgba(255, 255, 255, 0.1)',
    '--theme-border-secondary': 'rgba(255, 255, 255, 0.05)',
    '--theme-border-accent': 'rgba(201, 169, 98, 0.3)',
    '--theme-border-light': 'rgba(255, 255, 255, 0.1)',
    
    // ===== 阴影 =====
    '--theme-shadow-sm': '0 2px 8px rgba(0, 0, 0, 0.3)',
    '--theme-shadow-md': '0 4px 16px rgba(0, 0, 0, 0.4)',
    '--theme-shadow-lg': '0 8px 24px rgba(0, 0, 0, 0.5)',
    '--theme-shadow-xl': '0 12px 40px rgba(0, 0, 0, 0.6)',
    '--theme-shadow-card': '0 4px 24px rgba(0, 0, 0, 0.3)',
    '--theme-shadow-card-hover': '0 8px 32px rgba(201, 169, 98, 0.15)',
    '--theme-shadow-nav': '0 4px 20px rgba(0, 0, 0, 0.4)',
    '--theme-shadow-cta': '0 4px 16px rgba(201, 169, 98, 0.3)',
    '--theme-shadow-cta-hover': '0 8px 24px rgba(201, 169, 98, 0.4)',
    '--theme-shadow-glow': '0 0 40px rgba(201, 169, 98, 0.15)',
    
    // ===== 导航栏专用 =====
    '--theme-nav-bg': 'rgba(10, 15, 26, 0.95)',
    '--theme-nav-text': '#ffffff',
    '--theme-nav-text-hover': '#c9a962',
    '--theme-nav-dropdown-bg': 'rgba(26, 35, 50, 0.95)',
    '--theme-nav-dropdown-text': '#ffffff',
    '--theme-nav-dropdown-hover': 'rgba(201, 169, 98, 0.2)',
    
    // ===== 按钮样式 =====
    '--theme-btn-primary-bg': 'linear-gradient(135deg, #c9a962 0%, #a08347 100%)',
    '--theme-btn-primary-text': '#0a0f1a',
    '--theme-btn-cta-bg': 'linear-gradient(135deg, #c9a962 0%, #a08347 100%)',
    '--theme-btn-cta-text': '#0a0f1a',
    
    // ===== 卡片样式 =====
    '--theme-card-bg': 'rgba(26, 35, 50, 0.8)',
    '--theme-card-border': 'rgba(255, 255, 255, 0.1)',
    '--theme-card-border-top': '#c9a962',
    '--theme-card-radius': '16px',
    '--theme-card-backdrop': 'blur(10px)',
    
    // ===== 统计数据区域 =====
    '--theme-stat-number': '#c9a962',
    '--theme-stat-label': '#94a3b8',
    '--theme-stat-bg': 'rgba(26, 35, 50, 0.8)',
    
    // ===== 表单元素 =====
    '--theme-input-bg': 'rgba(26, 35, 50, 0.6)',
    '--theme-input-border': 'rgba(255, 255, 255, 0.1)',
    '--theme-input-focus-border': '#c9a962',
    '--theme-input-focus-shadow': '0 0 0 3px rgba(201, 169, 98, 0.2)',
    
    // ===== 排版 =====
    '--theme-font-heading': "'Playfair Display', 'Georgia', serif",
    '--theme-font-body': "'Inter', 'Segoe UI', sans-serif",
    
    // ===== 圆角 =====
    '--theme-radius-sm': '4px',
    '--theme-radius-md': '8px',
    '--theme-radius-lg': '12px',
    '--theme-radius-xl': '16px',
    '--theme-radius-full': '30px',
    
    // ===== 过渡动画 =====
    '--theme-transition-fast': '0.2s ease',
    '--theme-transition-normal': '0.3s ease',
    '--theme-transition-slow': '0.5s ease',
  }
};

export default modernDarkTheme;
